/**
 * Знак и написание BioFlow — те же, что в магазине и лендинге.
 *
 * Логотип — инлайновый SVG, а не файл в /public: знак весит меньше, чем
 * запрос за ним, а WebView Telegram открывается с холодным кэшем почти
 * каждый раз. Геометрия атома перенесена без изменений.
 */
const NODES = [
  { cx: 84.4, cy: 74.1 },
  { cx: 15.6, cy: 74.1 },
  { cx: 15.6, cy: 25.9 },
  { cx: 84.4, cy: 25.9 },
];

const MARK_TRANSFORM = "rotate(30 50 50) translate(3 3) scale(0.94)";

export function BrandMark({ size = 22 }: { size?: number }) {
  return (
    <svg viewBox="0 0 100 100" width={size} height={size} aria-hidden focusable="false">
      <g transform={MARK_TRANSFORM}>
        <g fill="none" stroke="rgba(255,255,255,0.55)" strokeWidth="6">
          {[35, -35].map((tilt) => (
            <ellipse key={tilt} cx="50" cy="50" rx="42" ry="22" transform={`rotate(${tilt} 50 50)`} />
          ))}
        </g>
        {NODES.map((node) => (
          <circle key={`${node.cx}-${node.cy}`} r="11" fill="#fff" {...node} />
        ))}
        <circle cx="50" cy="50" r="9" fill="none" stroke="#fff" strokeWidth="6" />
      </g>
    </svg>
  );
}

export function BrandHeader() {
  return (
    <div className="brand">
      <div className="brand__mark">
        <BrandMark />
      </div>
      <h1 className="brand__name">
        Bio<span className="brand__name-accent">Flow</span>
      </h1>
    </div>
  );
}
